export default {
    home: 'home',
    fax: 'print',
    cell: 'mobile',
    work: 'building',
    other: 'fas fa-phone'
}
